<template>
  <appTable
    v-if="shouldRenderConfig"
    :tableName="name"
    :tableClass="getClassName"
  >
    <div v-if="shouldRenderConfig" :class="getClassName">
      <component
        :is="getBundleProductPartAttributeType(pp.type)"
        v-for="pp in getBundlePP"
        :key="pp.code"
        :propsData="pp"
        alwaysShow="true"
        :excel="pp.excel"
      ></component>
    </div>
  </appTable>
</template>
<script>
import { useWebproductStore } from "@/stores/modules/webproduct";
import { useBundleStore } from "@/stores/modules/bundle";
import { mapState, mapActions } from "pinia";

import { i18n } from "../../i18n";

export default {
  computed: {
    ...mapState(useBundleStore, ["getBundleAllActiveProductParts"]),
    ...mapState(useWebproductStore, ["getProductPartsNames"]),
    name: () => {
      return i18n.t("Upload");
    },
    getBundlePP: function () {
      return this.getBundleAllActiveProductParts.map(el => {
        return { code: el.id, label: el.text, type: el.type, excel: el.excel };
      });
    }
  },
  methods: {
    getBundleProductPartAttributeType: function (type) {
      if (type == "personalize") {
        return "appPersonalizationButton";
      }
      return "appUpload";
    }
  }
};
</script>
